/*eslint-disable */

declare global {
    interface Window {
        dataLayer: any;
    }
}

export const loadGtag = () => {
    const isAlreadyLoaded = document.querySelector('script[src="https://www.googletagmanager.com/gtag/js?id=G-Q4CRRYBXZL"]');
    if (isAlreadyLoaded) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-Q4CRRYBXZL';
    document.head.appendChild(script);

    script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) {
            window.dataLayer.push(args);
        }
        gtag('js', new Date());
        gtag('config', 'G-Q4CRRYBXZL');
    };
};